import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Scale extends OBase {
  update () {
    let geomInputTree = this.getObjectInput('Geometry');
    let cenInputTree = this.getVector3Input('Center', false);
    let factInputTree = this.getFloatInput('Factor');

    let geometryOutput = this.outputs['Geometry'].paramObject;

    let dataTrees = [geomInputTree, cenInputTree, factInputTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let geomInput = outDataTrees[0].branches[i][j];
        let centerInput = outDataTrees[1].branches[i][j];
        let factorInput = outDataTrees[2].branches[i][j];

        var scaledObject = ScaleObject(geomInput, centerInput, factorInput);
        outTree.add(scaledObject, outDataTrees[0].paths[i]);
      }
    }

    geometryOutput.value = outTree;
  }
}

function ScaleObject (geomInput, centerInput, factorInput) {
  if (geomInput instanceof THREE.Geometry) {
    let g = geomInput.clone();
    g.vertices.forEach(v => {
      v.set(v.x - centerInput.x, v.y - centerInput.y, v.z - centerInput.z);
      v.multiplyScalar(factorInput);
      v.set(v.x + centerInput.x, v.y + centerInput.y, v.z + centerInput.z);
    });

    return g;
  } else {
    let paths = geomInput;

    let scaledPaths = [];
    for (let k = 0; k < paths.length; k++) {
      let path = paths[k];
      scaledPaths.push([]);
      for (let t = 0; t < path.length; t++) {
        let pt = path[t];
        let scaledPt = new ClipperLib.DoublePoint(pt.X - centerInput.x, pt.Y - centerInput.y);
        let p = new THREE.Vector3(scaledPt.X, scaledPt.Y, 0);
        p.multiplyScalar(factorInput);
        scaledPt = new ClipperLib.DoublePoint(p.x + centerInput.x, p.y + centerInput.y);
        scaledPaths[k].push(scaledPt);
      }
    }

    return scaledPaths;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Scale.js